import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Book } from "../../app/models/book";
import React, { Fragment } from "react";

interface Props {
  book: Book;
}

const BookOnlineRetailerListings: React.FC<Props> = ({ book }) => {
  const bookFormats = book.editions.map(edition => edition.bookFormat);

  return (
    <>
      <Typography variant="body1">Online Retailer Listings</Typography>
      {bookFormats.map((format: string) => (
        <Fragment key={format}>
          <Typography variant="body2" sx={{color: '#369aac'}}>{format}</Typography>
          <List dense={true}>
            {book.onlineListings.filter((listing) => {
              return listing.format === format;
            }).length === 0 ? (
              <Typography variant="body2">
              No listings yet, please check back soon
              </Typography>
            ) : (
              book.onlineListings
                .filter((listing) => {
                  return listing.format === format;
                })
                .map((listing, index) => (
                  <a
                    href={listing.listingUrl}
                    target="_blank"
                    rel="noreferrer noopener"
                    key={`${format}${index}`}
                    style={{ textDecoration: "none", color: "#000" }}
                  >
                    <ListItemButton>
                      <ListItemIcon>
                        <OpenInNewIcon />
                      </ListItemIcon>
                      <ListItemText primary={listing.name} />
                    </ListItemButton>
                  </a>
                ))
            )}
          </List>
        </Fragment>
      ))}
    </>
  );
};

export default BookOnlineRetailerListings;
